document.querySelector(".redo-quiz a").addEventListener("click",function(){
  this.setAttribute("disabled","disabled");
  this.innerHTML = "Loading...";
});

addtocart();

function addtocart(){
    const addtocart = document.querySelectorAll(".quiz-prod-atc");
    const quizSwatches = document.querySelectorAll(".prod-variant-swatches");
    quizSwatches.forEach((swatch)=>{
      swatch.querySelectorAll("input[type='radio']").forEach((input)=>{
        input.addEventListener("change",function(){
          let val = "";
          this.closest(".prod-variant-swatch").querySelector(".quiz-selected-value").innerHTML = input.value;
          this.closest(".prod-variant-swatches").querySelectorAll("input[type='radio']:checked").forEach((inpt,index)=>{
            if(index == 0)
            {
              val += inpt.value;
            }
            else
            {
              val += " / "+inpt.value;
            }
          });
          if(this.closest(".quiz-prod-variant").querySelector("option[data-title='"+val+"']") != null)
          {
            let vid = this.closest(".quiz-prod-variant").querySelector("option[data-title='"+val+"']").value;
            this.closest(".quiz-prod-variant").querySelector("[name='id']").value = vid;
            this.closest(".quiz-prod-atc").querySelector("button[type='button']").removeAttribute("disabled");
            this.closest(".quiz-prod-atc").querySelector("button[type='button']").innerHTML = "Add to cart";
          }
          else
          {
            this.closest(".quiz-prod-atc").querySelector("button[type='button']").setAttribute("disabled","disabled");
            this.closest(".quiz-prod-atc").querySelector("button[type='button']").innerHTML = "Sold Out";
          }
          
        });
      });
    });
    addtocart.forEach((atc)=>{
      atc.querySelector("button").addEventListener("click",function(){
        atc.querySelector("button").setAttribute("disabled","disbled");
        let _this = atc;
        let id = atc.closest(".quiz-prod-atc").querySelector("[name=id]").value;
        let formData = {
         'items': [{
          'id': id,
          'quantity': 1
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          _this.querySelector("button").removeAttribute("disabled");
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          setTimeout(function(){
             document.querySelector("cart-drawer").setAttribute("open","");
          },1000);
          return response.json();  
        })
        .catch((error) => {
          console.error('Error:', error);
          _this.removeAttribute("disabled");
        });

      });
    })
  }